export const Enums = {
    recent_news_noti_type: {
        news: 1,
        notification: 2,
    }
}